import React, { Fragment, lazy, Suspense } from "react";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import Loading from "@genericComponents/Loading.js";
import { DIALOGHOLDER } from "@genericComponents/CFW.js";
const ShowDialog = lazy(() => import("@controls/Dialogs/ShowDialog.js"));
export const Dialog = () => {
  const param = useGenericStore(DIALOGHOLDER);
  if (param) {
    return (
      <Suspense fallback={<Loading />}>
        <ShowDialog param={param} />
      </Suspense>
    );
  }
  return <Fragment />;
};
